import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaTitleComponent } from '@priva/components/title';
import { TranslateService } from '@priva/localization';

import { RegistrationsTableComponent } from 'app/shared/components';
import { resetApiConfig } from 'app/state/api-config/api-config.actions';
import { resetMasterDataState } from 'app/state/master-data/master-data.actions';
import { resetMultiUserPreferences } from 'app/state/multi-user-preferences/multi-user-preferences.actions';
import { resetRegistrationState } from 'app/state/registrations/registrations.actions';
import { userLogout } from 'app/state/user-session/user-session.actions';

@Component({
    selector: 'app-developer',
    templateUrl: './app-developer.component.html',
    styleUrl: './app-developer.component.scss',
    imports: [PrivaButtonComponent, PrivaTitleComponent, RegistrationsTableComponent],
})
export class AppDeveloperComponent {
    private store = inject(Store);
    private translateService = inject(TranslateService);

    toggleLanguage(): void {
        // By default, PrivaLocalizationService will use to handle all locale settings
        // This method is meant to be used for testing in Developer mode without the need to change the browser language
        // Do not use translateService directly outside app-developer.component.ts
        this.translateService.use(this.translateService.currentLang === 'nl-NL' ? 'en-US' : 'nl-NL');
    }

    clearMasterData(): void {
        this.store.dispatch(resetMasterDataState());
    }

    clearPreferences(): void {
        this.store.dispatch(resetMultiUserPreferences());
    }

    clearAll(): void {
        this.store.dispatch(resetApiConfig());
    }

    clearRegistrations(): void {
        this.store.dispatch(resetRegistrationState());
    }

    mockServerLogin() {
        window.localStorage.setItem(
            'ngx-webstorage|settings-identifier',
            '"site;0;helpdeskhelpdesk;F8d/7fgQvR7uvnOStOSbbgh+e+P5LSqo2yiKeCUlxL5VpSrbs8wz0Eic45bbSRvn"',
        );
        window.localStorage.setItem('ngx-webstorage|employeenumber', '1');
        window.localStorage.setItem('ngx-webstorage|pin-code', '"1111"');
        window.localStorage.setItem('ngx-webstorage|apiversion', '5');
    }

    logout() {
        this.store.dispatch(userLogout());
    }
}
